import { Plugins } from '@capacitor/core';
import axios, { AxiosResponse } from 'axios';

import DBStorage from './DBStorage';
import { baseUrl, isWebView, passToWebView, reactIsInDevelopmentMode, setTokens } from './Funcs';
import { log } from 'console';

const { Device } = Plugins;

// ارسال تمامی درخواست ها به سرور از طریق Axios انجام می شود

class Axios {
    baseLink = '';

    constructor() {
        this.baseLink = `${baseUrl}/api/v2`;
        axios.defaults.baseURL = this.baseLink;
    }

    getAccessToken = async () => {
        const storage = await new DBStorage().initRet();
        const user = await storage.get("user");
        let accessToken = '';

        if (isWebView()) {
            const token = await passToWebView("getPref", "access_token");

            if (token != '' && token != null) {
                accessToken = token;
            }
        } else {
            if (user) {
                accessToken = user.access_token;
            }
        }

        return accessToken;
    }

    getRefreshToken = async () => {
        const storage = await new DBStorage().initRet();
        const user = await storage.get("user");
        let refreshToken = '';

        if (isWebView()) {
            const token = await passToWebView("getPref", "refresh_token");


            if (token != '' && token != null) {
                refreshToken = token;
            }
        } else {
            if (user) {
                refreshToken = user.refresh_token;
            }
        }


        return refreshToken;
    }

    // تنظیمات ارسال تمامی درخواست ها
    AxiosConfig = async () => {
        const storage = await new DBStorage().initRet();
        const sessionId = await storage.get("sessionId");
        const info = await Device.getInfo();

        const params: any = {
            Platform: info.operatingSystem,
            PlatformVersion: info.osVersion,
            IsApp: String(isWebView())
        }

        const token = await this.getAccessToken();
        if (token != '') {
            params['Authorization'] = "Bearer " + token;
        }

        if (sessionId) {
            params['SessionID'] = sessionId;
        }

        if (isWebView()) {
            try {
                const token = await passToWebView('getNotifToken', '')!;
                params['Token'] = token;
            } catch (ex) {
                params['Token'] = '';
            }
        } else {
            params['Token'] = '';
        }

        return params
    }

    // ارسال تمامی درخواست های GET توسط این تابع انجام می شود
    get = async (url: string): Promise<AxiosResponse<any>> => {
        if (isWebView()) {
            try {
                const isConnected = await passToWebView("isConnected", "")!;
                if (!isConnected) {
                    return Promise.reject();
                }
            } catch (ex) { }
        }

        let config = await this.AxiosConfig();

        return new Promise((resolve, reject) => {
            axios.get(url, { headers: config }).then((response) => {
                return resolve(response);
            }).catch(async (error) => {
                if (error.response.status == 401) {
                    const refreshToken = await this.getRefreshToken();

                    try {
                        await axios.post("/post/token/refresh", {
                            token: refreshToken
                        }).then(async (refresh_response) => {
                            const { access_token, refresh_token } = refresh_response.data;

                            setTokens(access_token, refresh_token);

                            config = await this.AxiosConfig();

                            return resolve(await axios.get(url, { headers: config }));
                        }).catch((refresh_error) => {
                            setTokens("", "");

                            window.location.href = window.location.origin;

                            return reject();
                        });
                    } catch (error) {
                        return reject();
                    }
                }
            });
        });
    }

    // ارسال تمامی درخواست های POST توسط این تابع انجام می شود
    post = async (url: string, params: any): Promise<AxiosResponse<any>> => {
        let config = await this.AxiosConfig();

        return new Promise((resolve, reject) => {
            axios.post(url, params, { headers: config }).then((response) => {
                return resolve(response);
            }).catch(async (error) => {
                if (error.response.status == 401) {
                    const refreshToken = await this.getRefreshToken();

                    try {
                        await axios.post("/post/token/refresh", {
                            token: refreshToken
                        }).then(async (refresh_response) => {
                            const { access_token, refresh_token } = refresh_response.data;

                            setTokens(access_token, refresh_token);

                            config = await this.AxiosConfig();

                            return resolve(await axios.post(url, params, { headers: config }));
                        }).catch((refresh_error) => {
                            setTokens("", "");

                            return reject();
                        });
                    } catch (error) {
                        return reject();
                    }
                }
            });
        });
    }
}

export default Axios